import { jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { NotImplementedBlock } from "../../components/NotImplementedBlock/NotImplementedBlock.js";
const EmptyComponentHandle = "$$fragment$$";
class DefaultComponentFactory {
  constructor(initialComponents) {
    this.registry = /* @__PURE__ */ new Map();
    this.register("NotImplementedBlock", NotImplementedBlock);
    if (initialComponents) this.registerAll(initialComponents);
  }
  register(type, component, useSuspense = false, loader) {
    const registryKey = processComponentTypeHandle(type);
    this.registry.set(registryKey, { type, component, useSuspense, loader });
  }
  registerAll(components) {
    components.forEach((c) => {
      const registryKey = processComponentTypeHandle(c.type);
      this.registry.set(registryKey, c);
    });
  }
  has(type) {
    const registryKey = processComponentTypeHandle(type);
    return this.registry.has(registryKey);
  }
  resolve(type, ctx) {
    const registryKey = processComponentTypeHandle(type);
    const entry = this.registry.get(registryKey);
    if (!entry) return void 0;
    if (entry.useSuspense !== true) return entry.component;
    const EntryComponent = entry.component;
    const EntryLoader = entry.loader;
    function Suspended(props) {
      return /* @__PURE__ */ jsx(Suspense, { fallback: EntryLoader && /* @__PURE__ */ jsx(EntryLoader, { ...props }), children: /* @__PURE__ */ jsx(EntryComponent, { ...props }) });
    }
    return Suspended;
  }
  resolveLoader(type) {
    const registryKey = processComponentTypeHandle(type);
    const entry = this.registry.get(registryKey);
    if (!entry) return void 0;
    if (entry.useSuspense === true) return void 0;
    return entry.component;
  }
  resolveFlags(type) {
    const registryKey = processComponentTypeHandle(type);
    const entry = this.registry.get(registryKey);
    if (!entry) return void 0;
    return entry.flags;
  }
  remove(type) {
    const registryKey = processComponentTypeHandle(type);
    if (!this.registry.has(registryKey)) return true;
    return this.registry.delete(registryKey);
  }
}
function processComponentTypeHandle(handle) {
  if (typeof handle === "string") return handle === "" ? EmptyComponentHandle : handle;
  throw new Error(`Invalid component type handle: ${typeof handle}`);
}
export {
  DefaultComponentFactory,
  EmptyComponentHandle
};
//# sourceMappingURL=default.js.map
